import React from 'react';
import { useSelector } from 'react-redux';
import {
    DefaultHeader, DoubleHeader, PostSidebar,
} from 'mm-ui-components';
import { getSecondaryHeader } from '../../store/navigation/doubleHeader/secondaryHeader/secondaryHeader.selectors';

interface PostSidebarProps {
  adId1: string | null;
  adId2: string | null;
}

export const DoubleHeaderPostSidebarConnected: React.FunctionComponent<PostSidebarProps> = props => {
  const isSecondaryHeaderEnabled = !!useSelector(getSecondaryHeader);
  return (
    <DoubleHeader doesSecondaryHeaderExist={isSecondaryHeaderEnabled}>
      <PostSidebar {...props} />
    </DoubleHeader>
);
};

export const DefaultHeaderPostSidebarConnected: React.FunctionComponent<PostSidebarProps> = props => {
  const doesSubHeaderExist = !!useSelector(getSecondaryHeader);
  return (
    <DefaultHeader doesSubHeaderExist={doesSubHeaderExist}>
      <PostSidebar {...props} />
    </DefaultHeader>
);
};
